import { combineReducers, configureStore } from "@reduxjs/toolkit";
import authReducer from "src/page/auth/loginSlice";
import { createTransform, persistReducer, persistStore, type PersistConfig } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import dashboardReducer from "./dashboard/dashboardSlice";
import userReducer from "./users/usersSlice";
import walletReducer from "./wallets/walletSlice";
import userDetailReducer from "src/page/userDetail/userDetailSlice";
import walletDetailReducer from "src/page/walletDetail/walletDetailSlice";
import transactionReducer from "src/page/transactions/transactionSlice";
import cardReducer from "src/page/cards/cardSlice";
import organisationReducer from "src/page/organisation/organisationSlice";
import organisationDetailReducer from "src/page/organisationDetail/organisationDetailSlice";
import superledgerReducer from "src/page/superLedger/superLedgerSlice";
import filterReducer from "src/page/filtersSlice";
import newPaymentReducer from "src/page/newPayment/newPaymentSlice";
import budgetReducer from "src/page/budget/budgetSlice";
import changePinReducer from "src/page/changePin/changePinSlice";
import homeReducer from "src/page/home/homeSlice";
import depositReducer from "src/page/deposit/depositSlice";
import activityReducer from "src/page/activity/activitySlice";
import ledgerReducer from "src/page/ledger/ledgerSlice";
import onBoardingReducer from "src/page/onBoarding/onBoardingSlice";
import internalDashboardReducer from "src/page/internalDashboard/InternalDashboardSlice";
import internalUserReducer from "src/page/internalUser/internalUserSlice";
import internalWalletReducer from "src/page/internalWallets/internalWalletSlice";
import internalfileReducer from "src/page/internalFile/internalIFileSlice";
import internalCardsReducer from "src/page/internalcards/internalcardSlice";
import bulkUploadReducer from "src/page/bulkUpload/bulkUploadSlice";
import internalBulkUploadReducer from "src/page/internalBulkUpload/internalBulkUploadSlice";
import internalNovattiFileContentsReducer from "src/page/internalNovattiFileContents/internalNovattiFileContentsSlice";
import internalfileContentReducer from "src/page/internalFileContent/internalIFileContentSlice";
import cardSettingReducer from "src/page/cardSetting/cardSettingSlice";
import internalTransactionReducer from "src/page/internalTransactions/InternalTransactionSlice";
import plansReducer from "src/page/plans/plansSlice";
import childrenPlansReducer from "src/page/childrenPlans/childrenPlansSlice";
import mccReducer from "src/page/mcc/mccSlice";
import referralProgramReducer from "src/page/referralProgram/referralProgramSlice";
import uploadFilesReducer from "src/page/uploadFiles/uploadFilesSlice";
import reportsReducer from "src/page/reports/reportsSlice";
import reportsContentReducer from "src/page/reportsContent/reportsContentSlice";
import analyticsReducer from "src/page/analytics/analyticsSlice";
import groupReducer from "src/page/group/groupSlice";
import groupDetailReducer from "src/page/groupDetail/groupDetailSlice";
import xeroReducer from "src/page/xero/xeroSlice";
import accountingIntegrationsReducer from "src/page/accountingIntegrations/accountingIntegrationsSlice";
import recurringTransferReducer from "src/page/recurringTransfer/recurringTransferSlice";
import organisationReportsReducer from "src/page/organisationReports/organisationReportsSlice";
import licenceReportsReducer from "src/page/licenceReports/licenceReportsSlice";
import licenceReportsContentReducer from "src/page/licenceReportsContent/licenceReportsContentSlice";
import walletReportsReducer from "src/page/walletReports/walletReportsSlice";
import walletReportsContentReducer from "src/page/walletReportsContent/walletReportsContentSlice";
import internalReportsReducer from "src/page/internalReports/internalReportsSlice";
import expenseReducer from "src/page/expense/expenseSlice";
import reimbursementReducer from "src/page/approvals/slices/reimbursementSlice";
import internalOrderReducer from "src/page/internalOrder/internalOrderSlice";
import expenseDetailReducer from "src/page/expenseDetail/expenseDetailSlice";
import transactionDetailReducer from "src/page/transactionDetail/transactionDetailSlice";
import stripeTransactionHistoryReducer from "src/page/stripeTransactionHistory/stripeTransactionHistorySlice";
import entitlementReducer from "src/page/entitlement/entitlementSlice";
import userNamesReducer from "src/page/userNamesSlice";
import chatReducer from "src/page/chat/chatSlice";
import masterCatalogReducer from "src/page/masterCatalog/masterCatalogSlice";
import workflowsReducer from "src/page/workflows/workflowsSlice";
import workflowDetailReducer from "src/page/workflowDetail/workflowDetailSlice";
import workflowNewReducer from "src/page/workflowNew/workflowNewSlice";
import workflowEditReducer from "src/page/workflowEdit/workflowEditSlice";
import { xeroMetaApi } from "src/page/xero/xeroMetaApi";
import type { AuthState } from "src/page/auth/loginSlice";
import { isCookieAuthMode } from "src/config/Config";
import { purgeLegacyTokenStorage } from "src/utils/sessionUtils";

const rootReducer = combineReducers({
  auth: authReducer,
  dashboard: dashboardReducer,
  onBoarding: onBoardingReducer,
  user: userReducer,
  wallet: walletReducer,
  userDetail: userDetailReducer,
  walletDetail: walletDetailReducer,
  transaction: transactionReducer,
  cards: cardReducer,
  organisation: organisationReducer,
  organisationDetail: organisationDetailReducer,
  superledger: superledgerReducer,
  newPayment: newPaymentReducer,
  budget: budgetReducer,
  changePin: changePinReducer,
  home: homeReducer,
  deposit: depositReducer,
  activity: activityReducer,
  filters: filterReducer,
  ledger: ledgerReducer,
  internalDashboard: internalDashboardReducer,
  internalUser: internalUserReducer,
  internalWallet: internalWalletReducer,
  internalCard: internalCardsReducer,
  internalfile: internalfileReducer,
  bulkUpload: bulkUploadReducer,
  internalBulkUpload: internalBulkUploadReducer,
  internalNovattiFileContents: internalNovattiFileContentsReducer,
  internalFileContent: internalfileContentReducer,
  cardSetting: cardSettingReducer,
  internalTransaction: internalTransactionReducer,
  plans: plansReducer,
  childrenPlans: childrenPlansReducer,
  mcc: mccReducer,
  referralProgram: referralProgramReducer,
  uploadFiles: uploadFilesReducer,
  reports: reportsReducer,
  reportsContent: reportsContentReducer,
  analytics: analyticsReducer,
  group: groupReducer,
  groupDetail: groupDetailReducer,
  xero: xeroReducer,
  accountingIntegrations: accountingIntegrationsReducer,
  recurringTransfer: recurringTransferReducer,
  organisationReports: organisationReportsReducer,
  licenceReports: licenceReportsReducer,
  licenceReportsContent: licenceReportsContentReducer,
  walletReports: walletReportsReducer,
  walletReportsContent: walletReportsContentReducer,
  internalReports: internalReportsReducer,
  expense: expenseReducer,
  reimbursement: reimbursementReducer,
  expenseDetail: expenseDetailReducer,
  transactionDetail: transactionDetailReducer,
  stripeTransactionHistory: stripeTransactionHistoryReducer,
  internalOrder: internalOrderReducer,
  entitlement: entitlementReducer,
  userNames: userNamesReducer,
  chat: chatReducer,
  masterCatalog: masterCatalogReducer,
  workflows: workflowsReducer,
  workflowDetail: workflowDetailReducer,
  workflowNew: workflowNewReducer,
  workflowEdit: workflowEditReducer,
  [xeroMetaApi.reducerPath]: xeroMetaApi.reducer
});

type RootReducerState = ReturnType<typeof rootReducer>;

// Cookie mode never writes Cognito tokens to storage; the HttpOnly cookie is the only credential.
// The in-flight challenge token is never persisted in either mode (it can complete a sign-in for 5 minutes).
const authTokenTransform = createTransform<AuthState, AuthState, RootReducerState>(
  (inbound) => {
    const stripped = { ...inbound, challengeToken: null };

    if (!isCookieAuthMode()) return stripped;

    return { ...stripped, cognitoIdToken: null, cognitoAccessToken: null, cognitoRefreshToken: null, token: null };
  },
  (outbound) => outbound,
  { whitelist: ["auth"] }
);

const persistConfig: PersistConfig<RootReducerState> = {
  key: "root",
  storage,
  whitelist: ["auth", xeroMetaApi.reducerPath],
  transforms: [authTokenTransform]
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(xeroMetaApi.middleware)
});

export type StoreDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;

purgeLegacyTokenStorage();

export const persistor = persistStore(store);
export const useAppDispatch: () => StoreDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export default store;
